/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PageSwitch.vue?vue&type=template&id=db95586e&scoped=true&"
import script from "./PageSwitch.vue?vue&type=script&lang=js&"
export * from "./PageSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PageSwitch.vue?vue&type=style&index=0&id=db95586e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db95586e",
  null
  
)

export default component.exports